export const electratel = [
    {
      id: 1,
      title: "Intro",
      img:
        "assets/electratel/electratel.jpg",
      link:
        "assets/electratel/electratel.jpg"
    },
    {
      id: 2,
      title: "Layout 1",
      img:
        "assets/electratel/layout1.png",
      link:
        "assets/electratel/layout1.pdf"
    },
    {
      id: 3,
      title: "Layout 2",
      img:
        "assets/electratel/layout2.png",
      link:
        "assets/electratel/layout2.pdf"
    },
    {
      id: 4,
      title: "Construction work",
      img:
        "assets/electratel/construction.png",
      link:
        "assets/electratel/construction.png"
    },
  ];
  
  export const coffeeShop = [
    {
      id: 1,
      title: "Intro",
      img:
        "assets/coffeeshop/cafeteria.png",
      link:
        "assets/coffeeshop/cafeteria.png"
    },
    {
      id: 2,
      title: "Side view",
      img:
        "assets/coffeeshop/pbp1A.png",
      link:
        "assets/coffeeshop/pbp1A.pdf"
    },
    {
      id: 3,
      title: "Topdown view",
      img:
        "assets/coffeeshop/pbp1B.png",
      link:
        "assets/coffeeshop/pbp1B.pdf"
    },
    {
      id: 4,
      title: "Base floor",
      img:
        "assets/coffeeshop/p0.png",
      link:
        "assets/coffeeshop/p0.pdf"
    },
    {
      id: 5,
      title: "1º floor",
      img:
        "assets/coffeeshop/p1.png",
      link:
        "assets/coffeeshop/p1.pdf"
    },
    {
      id: 6,
      title: "Underground",
      img:
        "assets/coffeeshop/subterraneo.png",
      link:
        "assets/coffeeshop/subterraneo.pdf"
    },
    {
      id: 7,
      title: "Roof",
      img:
        "assets/coffeeshop/tejado.png",
      link:
        "assets/coffeeshop/tejado.pdf"
    },
  ];
  
  export const averly = [
    {
      id: 1,
      title: "Intro",
      img:
        "assets/averly/intro.jpg",
      link:
        "assets/averly/intro.jpg"
    },
    {
      id: 2,
      title: "Info",
      img:
        "assets/averly/info.png",
      link:
        "assets/averly/info.pdf"
    },
    {
      id: 3,
      title: "Individual House",
      img:
        "assets/averly/individualHouse.jpg",
      link:
        "assets/averly/individualHouse.jpg"
    },
    {
      id: 4,
      title: "Render",
      img:
        "assets/averly/render.jpg",
      link:
        "assets/averly/render.jpg"
    },
  ];
  
  export const drawing = [
    {
      id: 1,
      title: "Intro",
      img:
        "assets/drawing/intro.jpg",
      link:
        "assets/drawing/intro.jpg"
    },
    {
      id: 2,
      title: "1",
      img:
        "assets/drawing/1.jpg",
      link:
        "assets/drawing/1.jpg"
    },
    {
      id: 3,
      title: "2",
      img:
        "assets/drawing/2.jpg",
      link:
        "assets/drawing/2.pdf"
    },
    {
      id: 4,
      title: "3",
      img:
        "assets/drawing/3.jpg",
      link:
        "assets/drawing/3.pdf"
    },
    {
      id: 5,
      title: "4",
      img:
        "assets/drawing/4.jpg",
      link:
        "assets/drawing/4.jpg"
    },
    {
      id: 6,
      title: "5",
      img:
        "assets/drawing/5.jpg",
      link:
        "assets/drawing/5.jpg"
    },
    {
      id: 7,
      title: "6",
      img:
        "assets/drawing/6.jpg",
      link:
        "assets/drawing/6.jpg"
    },
  ];
  
  export const cubeHome = [
    {
      id: 1,
      title: "Intro",
      img:
        "assets/cube/intro.png",
      link:
        "assets/cube/"
    },
    {
      id: 2,
      title: "Layout1",
      img:
        "assets/cube/layout1.jpg",
      link:
        "assets/cube/layout1.pdf"
    },
    {
      id: 3,
      title: "Layout2",
      img:
        "assets/cube/layout2.jpg",
      link:
        "assets/cube/layout2.pdf"
    },
  ];

  export const photo = [
    {
      id: 1,
      title: "Intro",
      img:
        "assets/photo/intro.jpg",
      link:
        "assets/photo/intro.jpg"
    },
    {
      id: 2,
      title: "Info",
      img:
        "assets/photo/info.jpg",
      link:
        "assets/photo/info.pdf"
    },
  ];
  
